import React from 'react';
import { BrandStory } from '../components/home/BrandStory';

export function OurStoryPage() {
  return <BrandStory />;
}
